import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import ActivityPage from '../../page/ActivityPage';
import store from '../../configureStore';
import * as orderActions from '../../actions/orders';
import productActions from '../../actions/products';
import * as settingActions from '../../actions/settings';
import ComponentWidgetContainer from '../ComponentWidgetContainer';

export default class ActivityWidgetContainer extends ComponentWidgetContainer {
  constructor(props) {
    super(props);

    const { product } = this.props;

    // here get data from api originally, later change to get from rails
    store.dispatch(productActions.fetchProduct(product)).then(() => {
      if (window.xprops && window.xprops.onProps) {
        window.xprops.onProps(({ data }) => {
          if (data && data.id) {
            store.dispatch(orderActions.setVariantsQuantity(`${data.id}_quantity`, 0));
          }
        });
      }
    });
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <ActivityPage />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = (value) => store.dispatch(settingActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingActions.setTranslation({ key, value }));
};
window.changeSetting = (key, value) => store.dispatch(settingActions.setSetting({ key, value }));

ActivityWidgetContainer.propTypes = {
  defaultTranslation: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
};
